import type { CopilotProposalSummary } from "@repo/app-types/entities/copilotProposal";
import type { To } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { buildPlaybookProposalEditLocation } from "../../components/playbookEditorUrlState.js";
import { buildCopilotProposalLocation } from "./copilotDeepLinks.js";
import { readCopilotProposalCardContent } from "./copilotProposalCard.js";

/**
 * The editor that puts a proposal into its draft, with the proposal to show.
 * Undefined when the proposal's card applies it in place instead.
 */
export function buildCopilotProposalEditorLocation(
  proposal: CopilotProposalSummary,
): To | undefined {
  switch (proposal.resource_type) {
    case "playbook":
      return buildPlaybookProposalEditLocation({
        playbookId: proposal.resource.id,
        proposalId: proposal.id,
      });
    case "teammateAgent":
      return buildCopilotProposalLocation(
        appPaths.teammateAgentInstructions.build({
          teammateAgentId: proposal.resource.id,
        }),
        proposal.id,
      );
    case "knowledgeBaseAttachment":
      return buildCopilotProposalLocation(
        appPaths.settingsKnowledgeBaseAttachment.build({
          knowledgeBaseId: proposal.data.knowledge_base_id,
          attachmentId: proposal.resource.id,
        }),
        proposal.id,
      );
    case "signal":
    case "automation":
    case "training":
    case "tool": {
      const { review } = readCopilotProposalCardContent(proposal);
      return review.kind === "open_editor" ? review.location : undefined;
    }
  }
}
